import { DeliveryProvider } from '../../../../../services/exports/Constants';

export default {
  title: 'Verificar cobertura de dirección',
  or: 'o',
  form: {
    company: {
      label: 'Seleccionar restaurante',
    },
    address: {
      label: 'Escribe la dirección',
    },
  },
  result: {
    positive: '{{address}} es apta para entrega externa',
    negative: '{{address}} no es apta para entrega externa',
  },
  providers: {
    [DeliveryProvider.FirstDelivery]: 'Uber',
    [DeliveryProvider.UberDrive]: 'Uber',
    [DeliveryProvider.WoltDrive]: 'Wolt',
  },
  buttons: {
    check: 'Verificar',
  },
  toasts: {
    error: 'Error al verificar la cobertura de la dirección',
  },
};
